<template>
  <v-dialog
    v-model="permissionDialog"
    width="90%"
    @click:outside="closePermissionDialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <p id="permissionDialog" v-bind="attrs" v-on="on" @click="openDialog"></p>
    </template>
    <v-card
      style="padding: 10px 20px 20px 20px; position: relative"
      class="text-center"
    >
      <v-row>
        <v-col md="12" style="padding: 0">
          <v-card-title>
            <v-spacer> </v-spacer>DAFTAR PENGAJUAN IZIN<v-spacer> </v-spacer>
            <v-btn
              small
              icon
              color="red"
              style="color: white; position: absolute; top: 5px; right: 5px"
              @click="closePermissionDialog"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-data-table
            mobile-breakpoint="0"
            fixed-header
            height="50vh"
            @click:row="openPermissionDetail"
            :headers="permissionHeaders"
            style="cursor: pointer"
            :items="filteredPermission"
            item-key="id"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
            }"
          >
            <template v-slot:[`item.employee`]="{ item }">
              <div
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ item.employee != null ? item.employee.name : '' }}
              </div>
            </template>
            <template v-slot:[`item.company`]="{ item }">
              <div
                v-if="item.company !== null"
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ item.company.name }}
              </div>
            </template>
            <template v-slot:[`item.department`]="{ item }">
              <div
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ item.department != null ? item.department.name : '' }}
              </div>
            </template>
            <template v-slot:[`item.permission_type`]="{ item }">
              <div
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{
                  item.permission_type !== null
                    ? item.permission_type.name
                    : '-'
                }}
              </div>
            </template>
            <template v-slot:[`item.start_date`]="{ item }">
              <div
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ convertDateTime(item.start_date) }}
              </div>
            </template>
            <template v-slot:[`item.end_date`]="{ item }">
              <div
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ convertDateTime(item.end_date) }}
              </div>
            </template>
            <!-- <template v-slot:[`item.created_at`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ convertDate(item.created_at) }}
                  </div>
                </template> -->
            <template v-slot:[`item.status_permission`]="{ item }">
              <div
                :style="`font-size:14px; padding: 0; display: flex; flex-direction: row; color:${statusColor(
                  item.status_permission
                )};`"
              >
                {{ requestStatus(item.status_permission) }}
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PermissionDialog',
  props: ['filteredPermission'],
  data() {
    return {
      permissionDialog: false,
      isLoading: false
    }
  },
  computed: {
    permissionHeaders() {
      return [
        {
          text: 'No. Pengajuan',
          value: 'request_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama',
          value: 'employee',
          align: 'left',
          sortable: false
        },
        {
          text: 'Perusahaan',
          value: 'company',
          align: 'left',
          sortable: false
        },
        {
          text: 'Department/ Section',
          value: 'department',
          align: 'left',
          sortable: false
        },
        {
          text: 'Jenis Izin',
          value: 'permission_type',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Izin',
          value: 'start_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Selesai',
          value: 'end_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Hari',
          value: 'total_permission_date',
          align: 'left',
          sortable: false
        },
        // {
        //   text: 'Dibuat Pada',
        //   value: 'created_at',
        //   align: 'left',
        //   sortable: false
        // },
        // {
        //   text: 'Dibuat Oleh',
        //   value: 'created_by_name',
        //   align: 'left',
        //   sortable: false
        // },
        {
          text: 'Status',
          value: 'status_permission',
          align: 'left',
          sortable: false
        }
      ]
    }
  },
  methods: {
    openDialog() {
      console.log(this.filteredLeaveList)
    },
    closeDialog() {
      this.pmeissionDialog = false
    },
    convertDateTime(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    convertDate2(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = Intl.DateTimeFormat('id', {
          day: 'numeric',
          month: 'long'
        }).format(date)
        return local
      }
    },
    closePermissionDialog() {
      this.permissionDialog = false
    },
    openPermissionDetail(item) {
      setTimeout(() => {
        window.open(`/hr/permission/detail/${item.id}`, '_blank')
      }, 100)
    },
    requestStatus(val) {
      switch (val) {
        case -2:
          return 'CANCELED'
        case -1:
          return 'REJECTED'
        case 0:
          return 'DRAFT'
        case 1:
          return 'WAITING APPROVAL'
        case 2:
          return 'APPROVED'
        default:
          break
      }
    },
    statusColor(val) {
      switch (val) {
        case -2:
          return 'red'
        case -1:
          return 'red'
        case 0:
          return 'blue'
        case 1:
          return 'orange'
        case 2:
          return 'green'
        default:
          break
      }
    }
  }
}
</script>

<style></style>
